export const argumentString = args => {
  return args
    ? Object.keys(args)
        .filter(key => ["page"].indexOf(key) === -1)
        .sort()
        .reduce((acc, key) => `${acc}${key}=${JSON.stringify(args[key])}&`, "^")
    : "^";
};

export const activeParams = () => {
  return {
    active: true,
    sort: "recent",
    limit: 100
  };
};

export const subjectsParams = (index, subscriptionVbid) => {
  const allSubjects = [
    {
      sort: "popular",
      filters: subjectsParamFilter(1, subscriptionVbid),
      limit: 100
    },
    {
      sort: "popular",
      filters: subjectsParamFilter(2, subscriptionVbid),
      limit: 100
    },
    {
      sort: "popular",
      filters: subjectsParamFilter(3, subscriptionVbid),
      limit: 100
    }
  ];
  return allSubjects[index] || allSubjects;
};

export const subjectsParamFilter = (index, subscriptionVbid) => {
  if (subscriptionVbid) {
    return [`recommended.subject` + index, `subscription.` + subscriptionVbid];
  } else {
    return [`recommended.subject` + index];
  }
};

export const formatBrandedSubscriptionCategoryParams = (
  lane,
  subscriptionVbid
) => {
  if (lane && subscriptionVbid) {
    return {
      sort: "popular",
      filters: ["Subject." + lane, "subscription." + subscriptionVbid],
      limit: 100
    };
  }
};

export const formatSubscriptionFilter = subscriptionVbid =>
  subscriptionVbid ? ["subscription." + subscriptionVbid] : null;

export const brandedSubscriptionCategoryParams = (lanes, subscriptionVbid) => {
  if (lanes && subscriptionVbid) {
    return lanes.map(lane => {
      return formatBrandedSubscriptionCategoryParams(lane, subscriptionVbid);
    });
  }
};

export const formatBrandedSubscriptionParams = subscriptionVbid => {
  if (subscriptionVbid) {
    return {
      sort: "popular",
      filters: formatSubscriptionFilter(subscriptionVbid),
      limit: 100
    };
  }
};

export const brandedSubscriptionParams = subscriptionVbids => {
  if (subscriptionVbids) {
    return subscriptionVbids.map(vbid => formatBrandedSubscriptionParams(vbid));
  }
};

export const trendParams = (key, subscriptionVbid) => {
  const exploreParams = {
    popular: {
      sort: "popular",
      filters: formatSubscriptionFilter(subscriptionVbid),
      limit: 100
    },
    recommended: {
      sort: "recommended",
      filters: formatSubscriptionFilter(subscriptionVbid),
      limit: 100
    },
    added: {
      sort: "added",
      filters: formatSubscriptionFilter(subscriptionVbid),
      limit: 100
    },
    all: {
      sort: "all",
      filters: formatSubscriptionFilter(subscriptionVbid),
      limit: 100
    }
  };

  if (key) {
    return exploreParams[key];
  }
  return [
    exploreParams.popular,
    exploreParams.recommended,
    exploreParams.added
  ];
};

export const allExplorerParams = () => {
  const allExplorerParams = [];
  return allExplorerParams.concat(subjectsParams(), trendParams());
};

export const isUnlimitedUserCredit = credit => {
  if (credit === undefined || credit === null) {
    return false;
  }
  return (
    credit.credits === undefined ||
    credit.credits === null ||
    credit.credits.total === -1
  );
};

export const isUnlimitedCopies = credit => {
  if (credit === undefined || credit === null) {
    return false;
  }
  return (
    credit.copies === undefined ||
    credit.copies === null ||
    credit.copies.total === -1
  );
};

export const creditsAreAvailable = credit =>
  isUnlimitedUserCredit(credit) ||
  credit.credits.available > 0 ||
  credit.credits.available === -1;

export const copiesAreAvailable = credit =>
  isUnlimitedCopies(credit) ||
  credit.copies.available > 0 ||
  credit.copies.available === -1;

export const showTranslatedEdition = edition => {
  const showEdition = window.location.hash
    ? window.location.hash.toLowerCase().search("#/explore")
    : -1;
  return !(!edition || showEdition < 0) && parseInt(edition) !== 0;
};
